@if(!isViewOnly) {
<h3>{{ title }}</h3>
}

@if(showNewBtn){
<p-button [disabled]="!hasPermissionEdit()" label="New" size="small" (click)="show()" />
}

<p-table id="oneToManyTable" [ngClass]="{ 'custom-view-only-table' : isViewOnly}" [columns]="cols" [value]="data.list"
  [tableStyle]="{ 'min-width': '50rem' }" [paginator]="isLimitedPagination ? limitedCount < data.total : true"
  [rows]="paginateQuery.take" [rowsPerPageOptions]="[10, 20, 50]" [showCurrentPageReport]="true" [loading]="loading()"
  currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [resizableColumns]="true"
  [lazy]="true" (onLazyLoad)="load($event)" [totalRecords]="data.total"
  [selectionMode]="manySelectable ? 'multiple' : (singleSelectable ? 'single' : null)" [selection]="currentSelection"
  (selectionChange)="currentSelection = $event">
  <ng-template pTemplate="header" let-columns>
    <tr>
      @if (manySelectable) {
      <th style="width: 5%;">
        <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
      </th>
      }

      @if (singleSelectable) {
      <th style="width: 5%;"></th>
      }

      <th *ngFor="let col of columns">
        <ng-container *ngIf="col.sortable !== false; else noSort">
          <span [pSortableColumn]="col.field">
            {{ col.header }}
            <p-sortIcon [field]="col.field"></p-sortIcon>
          </span>
        </ng-container>
        <ng-template #noSort>
          {{ col.header }}
        </ng-template>
      </th>

      <th style="width:5%"></th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-rowData let-columns="columns" let-index="rowIndex">
    <tr (click)="edit(rowData, index)" class="row-hover">

      @if (manySelectable) {
      <td>
        <p-tableCheckbox [value]="rowData" (click)="onSelectionCheckboxClick($event, rowData)"></p-tableCheckbox>
      </td>
      }

      @if (singleSelectable) {
      <td>
        <p-radioButton name="rowRadioButton" [value]="rowData" [(ngModel)]="selectedRadio"
          (click)="onSingleSelectionRadioClick($event, rowData)"></p-radioButton>
      </td>
      }

      <td *ngFor="let col of columns" [ngClass]="{ 'truncate max-w-[150px]' : col.isOverflowHorizontal }"
        tooltipPosition="top" [pTooltip]="col.isOverflowHorizontal ? rowData[col.field] : '' ">
        <ng-container [ngSwitch]="col.format">
          <ng-container *ngSwitchCase="'date'">
            {{
            rowData[col.field] === '--'
            ? rowData[col.field]
            : rowData[col.field] | utcToLocal: true | date:'MM/dd/yyyy'
            }}
          </ng-container>

          <ng-container *ngSwitchCase="'dateTime'">
            {{
            rowData[col.field] === '--'
            ? rowData[col.field]
            : rowData[col.field] | utcToLocal | date:'MM/dd/yyyy hh:mm a'
            }}
          </ng-container>

          <ng-container *ngSwitchCase="'decimal'">
            @if( rowData[col.field] !== '--') {
            $ {{ rowData[col.field] | number:'1.2-2'}}
            } @else {
            {{ rowData[col.field] }}
            }
          </ng-container>

          <ng-container *ngSwitchCase="'modal'">
            <div class="flex justify-center">
              <p-button [attr.title]="col.title" [label]="col.label || 'View'" size="small"
                (click)="openModal($event, rowData, col)" [disabled]="rowData[col.field] === '--'"
                aria-label="View details" />
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'link'">
            <ng-container *ngIf="rowData[col.field] !== '--'; else noLink">
              <a [href]="rowData[col.field]" target="_blank" rel="noopener noreferrer"
                (click)="$event.stopPropagation()">
                {{ rowData[col.field] }}
              </a>
            </ng-container>
            <ng-template #noLink>
              {{ rowData[col.field] }}
            </ng-template>
          </ng-container>

          <ng-container *ngSwitchCase="'linkButton'">
            <div class="flex justify-center">
              <p-button [label]="col.label || 'Open'" size="small" (click)="openLink($event, rowData[col.field])"
                [disabled]="rowData[col.field] === '--'" [attr.aria-label]="(col.label || 'Open') + ' link'" />
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'planType'">
            {{
            rowData[col.field] === '--'
            ? rowData[col.field]
            : rowData[col.field] | planTypeDescription
            }}
          </ng-container>

          <ng-container *ngSwitchCase="'quoteStatus'">
            <div class="flex items-center gap-2">
              <span class="status-badge" [ngClass]="rowData[col.field] | statusBadgeClass">
                <span class="status-text">{{ rowData[col.field] }}</span>
              </span>
              @if(statusUpdateAction) {
              <i class="pi pi-pencil text-blue-600 hover:text-blue-800 cursor-pointer"
                (click)="onStatusUpdateClick($event, rowData)"></i>
              }
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'template'">
            <ng-container [ngTemplateOutlet]="col.cellTemplate" [ngTemplateOutletContext]="{
    $implicit: rowData,
    row: rowData,
    value: rowData[col.field],
    col: col,
    index: index
  }">
            </ng-container>

          </ng-container>


          <ng-container *ngSwitchDefault>
            {{ rowData[col.field] }}
          </ng-container>
        </ng-container>
      </td>

      <td class="space-x-2">
        @if(hasFile) {
        <i class="pi pi-download text-blue-600 hover:text-blue-800 cursor-pointer"
          (click)="downloadFile($event, rowData)"></i>
        }
        @if(showDeleteBtn) {
        <i
          [ngClass]="{
            'text-gray-600 hover:text-gray-800': hasPermissionDelete(),
            'text-gray-400': !hasPermissionDelete()
          }"
          class="pi pi-times cursor-pointer"
          (click)="confirmDelete($event, rowData, id, index)"></i>
        }
      </td>
    </tr>
  </ng-template>
</p-table>

<p-dialog [(visible)]="modalVisible" [modal]="true" header="{{modalTitle || 'Details'}}" [dismissableMask]="true"
  [closable]="true" [draggable]="false" [resizable]="false"
  [style]="{ width: '60rem', minHeight: '20rem', maxWidth: '95vw' }" [contentStyle]="{
    'min-height': '15rem',
    'padding': '1.5rem',
    'font-size': '1rem',
    'line-height': '1.6'
  }">
  <ng-container *ngIf="modalTemplate; else defaultModalContent">
    <ng-container *ngTemplateOutlet="modalTemplate; context: modalContext"></ng-container>
  </ng-container>

  <ng-template #defaultModalContent>
    <div class="whitespace-pre-wrap">
      {{ modalText }}
    </div>
  </ng-template>

</p-dialog>
